export const HISTORY_DATE_FALLBACK = "-";

/**
 * Formats an ISO/Date value as "YYYY-MM-DD HH:mm:ss". The old history components' inline
 * `new Date(d).toISOString()...` threw RangeError on a missing/invalid date, which blanked the
 * whole modal. Returns HISTORY_DATE_FALLBACK instead.
 */
export const formatHistoryDate = (value: string | Date | null | undefined): string => {
  if (!value) return HISTORY_DATE_FALLBACK;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return HISTORY_DATE_FALLBACK;
  return date.toISOString().slice(0, 19).replace("T", " ");
};
